<template>
  <table class="f7 pa2 pv1-l fw4 w-100 mb2-l mb1">
    <tr class="table-row pv1">
      <td class="d1">
        <!-- left -->
        <div class="copy">
          <a href="http://reah.me" class="db link dim" title="reah">
            <span class="site-by">site by</span> <span class="reah ttu mr4-l mr2">Reah</span>
          </a>
        </div>
      </td>
      <td class="d2">
        &copy; Hayman Development 2017
      </td>
      <td class="d3">
        <a href="http://reah.me" class="db link dim" title="reah">
          <span class="site-by">site by</span> <span class="reah ttu mr4-l mr2">Reah</span>
        </a>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.d1 .d2 .d3 {
  display: table-cell;
}
.d1 {
  text-align: left;
}
.d2 {
  text-align:center;
}
.d3 {
  text-align:right;
}
.copy {
  visibility: hidden;
}
.copy, .d3 {
  white-space: nowrap;
}
.site-by {
  font-size: .6rem;
}
.space {

  letter-spacing: .25em;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue